import './assets/tailwind.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createGtm } from '@gtm-support/vue-gtm'
import App from './App.vue'
import router from './router'

const app = createApp(App)

app.use(createPinia())
app.use(router)

// Add GTM
app.use(createGtm({
  id: 'GTM-K9X4CV5G', // Replace with your actual GTM container ID
  enabled: true,
  debug: false,
  loadScript: true,
  vueRouter: router,
}))

app.mount('#app')
